import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import { useGetAllChartOfAccounts } from "../../../../hooks/api/queries";
import primaryComponents from "../../../primaryComponents";
import secondaryComponents from "../..";
import { useCheckoutHelper } from "../../../../hooks/useCheckoutHelper";

export const LedgerForm = ({ isRequired = false, errorMessage }) => {
  const { isLoading: isLoadingBankAccountsList, data: bankAccounts } =
    useGetAllChartOfAccounts({ is_bank_account: true });
  const { ledger_account_id, setLedgerAccount } = useCheckoutHelper();

  const selectedAccount = bankAccounts?.data?.find(
    (bankAccount) => `${bankAccount?.id}` === `${ledger_account_id}`,
  );

  return (
    <div
      className={`${globalStyles.cardWithBorder} flex-row align-items-center`}
      style={{ columnGap: "30px" }}
    >
      <div className="w-100">
        <secondaryComponents.LoaderHelper
          isLoading={isLoadingBankAccountsList}
          className="mt-1"
        >
          <primaryComponents.SelectField
            label={"Accounting"}
            placeholder={"Select Account"}
            options={bankAccounts?.data?.map((bank) => ({
              id: bank?.id,
              name: bank?.account_label,
            }))}
            idKey="id"
            nameKey="name"
            value={selectedAccount?.account_label || undefined}
            onChange={(value) => {
              setLedgerAccount(value);
            }}
            isRequired={isRequired ? isRequired : false}
            errorMessage={
              !ledger_account_id && errorMessage
                ? typeof errorMessage === "string"
                  ? { message: errorMessage }
                  : errorMessage
                : undefined
            }
            floatError={false}
            classNames="bank-name"
          />
        </secondaryComponents.LoaderHelper>
      </div>
    </div>
  );
};
